import React, { useState } from 'react';
import toast from 'react-hot-toast';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simulate form submission
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      toast.success('Message sent successfully! We\'ll get back to you soon.');
      setFormData({
        name: '',
        email: '',
        company: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', padding: '120px 20px 80px', backgroundColor: '#ffffff' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '80px' }}>
          <div style={{ 
            display: 'inline-block',
            padding: '8px 20px',
            backgroundColor: '#ede9fe',
            borderRadius: '24px',
            marginBottom: '24px'
          }}>
            <span style={{ color: '#7c3aed', fontSize: '14px', fontWeight: '600', letterSpacing: '0.5px' }}>
              CONTACT US
            </span>
          </div>
          <h1 style={{ 
            fontSize: '56px', 
            fontWeight: '800', 
            background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '24px',
            letterSpacing: '-1px',
            lineHeight: '1.1'
          }}>
            Get in Touch
          </h1>
          <p style={{ fontSize: '22px', color: '#6b7280', maxWidth: '700px', margin: '0 auto', lineHeight: '1.6' }}>
            Have questions? We're here to help. Reach out and we'll respond within 24 hours.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '40px', marginBottom: '60px' }}>
          {/* Contact Form */}
          <div style={{ 
            backgroundColor: '#ffffff', 
            padding: '48px', 
            borderRadius: '24px', 
            border: '1px solid #e5e7eb',
            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.05)' 
          }}>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', marginBottom: '8px' }}>
              Send us a message
            </h2>
            <p style={{ fontSize: '16px', color: '#6b7280', marginBottom: '32px' }}>
              Fill out the form below and we'll get back to you shortly.
            </p>
            
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '8px' }}>
                  Name *
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    fontSize: '16px'
                  }}
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '8px' }}>
                  Email *
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    fontSize: '16px'
                  }}
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '8px' }}>
                  Company
                </label>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    fontSize: '16px'
                  }}
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '8px' }}>
                  Subject *
                </label>
                <select
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    fontSize: '16px'
                  }}
                >
                  <option value="">Select a subject</option>
                  <option value="general">General Inquiry</option>
                  <option value="sales">Sales & Pricing</option>
                  <option value="support">Technical Support</option>
                  <option value="partnership">Partnership Opportunities</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div style={{ marginBottom: '24px' }}>
                <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '8px' }}>
                  Message *
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '8px',
                    fontSize: '16px',
                    resize: 'vertical'
                  }}
                />
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                style={{
                  width: '100%',
                  padding: '18px',
                  background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '12px',
                  fontSize: '17px',
                  fontWeight: '700',
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                  opacity: isSubmitting ? 0.7 : 1,
                  boxShadow: '0 8px 20px rgba(99, 102, 241, 0.3)',
                  transition: 'all 0.2s ease'
                }}
              >
                {isSubmitting ? 'Sending...' : 'Send Message →'}
              </button>
            </form>
          </div>

          {/* Contact Information */}
          <div>
            <div style={{ backgroundColor: 'white', padding: '40px', borderRadius: '16px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)', marginBottom: '30px' }}>
              <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1f2937', marginBottom: '24px' }}>
                Contact Information
              </h2>
              
              <div style={{ marginBottom: '24px' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                  <span style={{ fontSize: '24px', marginRight: '16px' }}>📧</span>
                  <div>
                    <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '4px' }}>Email</p>
                    <p style={{ fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>support@ventureos.com</p>
                  </div>
                </div>
              </div>

              <div style={{ marginBottom: '24px' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                  <span style={{ fontSize: '24px', marginRight: '16px' }}>🌐</span>
                  <div>
                    <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '4px' }}>Social Media</p>
                    <div style={{ display: 'flex', gap: '12px', marginTop: '8px' }}>
                      <a href="#" style={{ color: '#6366f1', textDecoration: 'none' }}>Twitter</a>
                      <a href="#" style={{ color: '#6366f1', textDecoration: 'none' }}>LinkedIn</a>
                      <a href="#" style={{ color: '#6366f1', textDecoration: 'none' }}>GitHub</a>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                  <span style={{ fontSize: '24px', marginRight: '16px' }}>⏰</span>
                  <div>
                    <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '4px' }}>Response Time</p>
                    <p style={{ fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>Within 24 hours</p>
                  </div>
                </div>
              </div>
            </div>

            {/* FAQ Quick Links */}
            <div style={{ 
              background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)', 
              padding: '40px', 
              borderRadius: '24px', 
              color: 'white',
              boxShadow: '0 10px 25px rgba(99, 102, 241, 0.3)'
            }}>
              <h3 style={{ fontSize: '22px', fontWeight: '700', marginBottom: '20px' }}>
                Quick Links
              </h3>
              <p style={{ fontSize: '15px', marginBottom: '24px', opacity: 0.9 }}>
                Looking for something specific?
              </p>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                <li style={{ marginBottom: '14px' }}>
                  <a href="/pricing" style={{ 
                    color: 'white', 
                    textDecoration: 'none', 
                    display: 'flex', 
                    alignItems: 'center',
                    fontSize: '16px',
                    fontWeight: '500'
                  }}>
                    → View Pricing Plans
                  </a>
                </li>
                <li style={{ marginBottom: '14px' }}>
                  <a href="/about" style={{ 
                    color: 'white', 
                    textDecoration: 'none', 
                    display: 'flex', 
                    alignItems: 'center',
                    fontSize: '16px',
                    fontWeight: '500'
                  }}>
                    → About VentureOS
                  </a>
                </li>
                <li style={{ marginBottom: '14px' }}>
                  <a href="/" style={{ 
                    color: 'white', 
                    textDecoration: 'none', 
                    display: 'flex', 
                    alignItems: 'center',
                    fontSize: '16px',
                    fontWeight: '500'
                  }}>
                    → Join Waitlist
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Back to Home */}
        <div style={{ textAlign: 'center' }}>
          <a 
            href="/" 
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '14px 28px',
              color: '#6b7280',
              border: '2px solid #e5e7eb',
              borderRadius: '12px',
              fontWeight: '600',
              textDecoration: 'none',
              fontSize: '16px',
              transition: 'all 0.2s ease'
            }}
          >
            ← Back to Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
